/* ============================================================
   Sách Tiếng Việt — gợi ý tìm kiếm ngay dưới ô nhập (không mở drawer)

   Vì sao phải viết mới: theme gắn <input is="ap-predictivesearchinput"> và
   custom element đó chỉ làm đúng một việc trong connectedCallback là
       addEventListener('click', () => document.getElementById(
         this.getAttribute('ap-controlsaria')).open = true)
   tức là bấm vào ô là mở drawer #search-drawer, còn toàn bộ logic gợi ý nằm
   BÊN TRONG drawer. Không có cách nào cấu hình để nó đổ ra inline.

   Cách gỡ hành vi đó mà không phá gì: dựng một <input> thuần, chép lại toàn bộ
   thuộc tính TRỪ `is` và `ap-controlsaria`, rồi thay vào chỗ cũ. Custom built-in
   element chỉ nâng cấp theo thuộc tính `is` lúc tạo phần tử, nên bản sao thuần
   sẽ không mang listener mở drawer nữa. Ô tìm kiếm trên mobile (mở bằng icon)
   vẫn giữ nguyên drawer như cũ.

   Muốn gỡ tính năng: xoá file này + xoá dòng <script> trong layout/theme.liquid.
   ============================================================ */
(function () {
  'use strict';

  var SCRIPT = document.currentScript;
  var MONEY = (SCRIPT && SCRIPT.dataset.moneyFormat) || '${{amount}}';
  var LIMIT = 6;
  var MIN_CHARS = 2;
  var DEBOUNCE = 220;

  function money(value) {
    var n = parseFloat(value);
    if (isNaN(n)) return '';
    var s = n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return MONEY.replace(/\{\{\s*amount[^}]*\}\}/, s);
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* Ảnh Shopify: xin đúng cỡ cần thay vì tải bản gốc 1200px */
  function thumb(url, px) {
    if (!url) return '';
    return url.indexOf('?') > -1 ? url + '&width=' + px : url + '?width=' + px;
  }

  function injectStyles() {
    if (document.getElementById('stv-suggest-styles')) return;
    var css = [
      '.stv-suggest-wrap{position:relative}',
      '.stv-suggest{position:absolute;z-index:60;left:0;right:0;top:calc(100% + 8px);',
      'background:#fff;border:1px solid #e6e6e6;border-radius:14px;',
      'box-shadow:0 18px 40px rgba(0,0,0,.13);overflow:hidden;max-height:70vh;overflow-y:auto}',
      '.stv-suggest[hidden]{display:none}',
      '.stv-suggest__item{display:flex;gap:12px;align-items:center;padding:10px 14px;',
      'text-decoration:none;color:inherit;border-bottom:1px solid #f2f2f2}',
      '.stv-suggest__item:last-of-type{border-bottom:0}',
      '.stv-suggest__item:hover,.stv-suggest__item.is-active{background:#f7f7f7}',
      '.stv-suggest__img{width:44px;height:60px;flex:0 0 44px;object-fit:cover;',
      'border-radius:4px;background:#f0f0f0}',
      '.stv-suggest__body{min-width:0;flex:1}',
      '.stv-suggest__title{font-size:14px;line-height:1.35;font-weight:600;color:#141414;',
      'display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}',
      '.stv-suggest__meta{font-size:12px;color:#8a8a8a;margin-top:2px;',
      'white-space:nowrap;overflow:hidden;text-overflow:ellipsis}',
      '.stv-suggest__price{font-size:14px;font-weight:700;color:#141414;white-space:nowrap}',
      '.stv-suggest__price--out{color:#9a9a9a;font-weight:600}',
      '.stv-suggest__foot{display:block;padding:12px 14px;text-align:center;font-size:13px;',
      'font-weight:600;color:#141414;text-decoration:none;background:#fafafa}',
      '.stv-suggest__foot:hover{background:#f0f0f0}',
      '.stv-suggest__empty{padding:18px 14px;text-align:center;font-size:13px;color:#8a8a8a}',
      /* hiện trên cả mobile — mobile không dùng drawer nữa */
      '@media (max-width:989px){.stv-suggest{max-height:60vh}}'
    ].join('');
    var el = document.createElement('style');
    el.id = 'stv-suggest-styles';
    el.textContent = css;
    document.head.appendChild(el);
  }

  function init(bar) {
    var form = bar.querySelector('form[action*="/search"]');
    var oldInput = bar.querySelector('input[name="q"]');
    if (!form || !oldInput || bar.dataset.stvSuggest) return;
    bar.dataset.stvSuggest = '1';

    /* Bản sao thuần, bỏ `is` + `ap-controlsaria` -> hết mở drawer */
    var input = document.createElement('input');
    Array.prototype.forEach.call(oldInput.attributes, function (a) {
      if (a.name === 'is' || a.name.indexOf('ap-') === 0) return;
      input.setAttribute(a.name, a.value);
    });
    input.value = oldInput.value;
    oldInput.parentNode.replaceChild(input, oldInput);

    injectStyles();
    form.classList.add('stv-suggest-wrap');

    var panel = document.createElement('div');
    panel.className = 'stv-suggest';
    panel.setAttribute('role', 'listbox');
    panel.hidden = true;
    form.appendChild(panel);

    input.setAttribute('autocomplete', 'off');
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-expanded', 'false');

    var timer = null;
    var controller = null;
    var active = -1;

    function close() {
      panel.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      active = -1;
    }

    function open() {
      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function items() {
      return panel.querySelectorAll('.stv-suggest__item');
    }

    function highlight(next) {
      var list = items();
      if (!list.length) return;
      if (active > -1 && list[active]) list[active].classList.remove('is-active');
      active = next < 0 ? list.length - 1 : next >= list.length ? 0 : next;
      list[active].classList.add('is-active');
      list[active].scrollIntoView({ block: 'nearest' });
    }

    function render(products, q) {
      var all = '/search?q=' + encodeURIComponent(q) + '&type=product';
      if (!products.length) {
        panel.innerHTML =
          '<div class="stv-suggest__empty">Không tìm thấy sách nào cho “' + esc(q) + '”</div>' +
          '<a class="stv-suggest__foot" href="' + all + '">Tìm trong toàn bộ cửa hàng</a>';
        open();
        return;
      }
      var html = products.map(function (p) {
        var img = thumb(p.featured_image && p.featured_image.url ? p.featured_image.url : p.image, 88);
        var meta = p.vendor && p.vendor !== window.Shopify_shop_name ? esc(p.vendor) : '';
        var price = p.available
          ? '<span class="stv-suggest__price">' + esc(money(p.price)) + '</span>'
          : '<span class="stv-suggest__price stv-suggest__price--out">Hết hàng</span>';
        return (
          '<a class="stv-suggest__item" role="option" href="' + esc(p.url) + '">' +
          (img ? '<img class="stv-suggest__img" src="' + esc(img) + '" alt="" loading="lazy" width="44" height="60">' : '<span class="stv-suggest__img"></span>') +
          '<span class="stv-suggest__body">' +
          '<span class="stv-suggest__title">' + esc(p.title) + '</span>' +
          (meta ? '<span class="stv-suggest__meta">' + meta + '</span>' : '') +
          '</span>' + price + '</a>'
        );
      }).join('');
      panel.innerHTML = html +
        '<a class="stv-suggest__foot" href="' + all + '">Xem tất cả kết quả cho “' + esc(q) + '”</a>';
      active = -1;
      open();
    }

    function search(q) {
      if (controller) controller.abort();
      controller = new AbortController();
      var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=' + LIMIT +
        '&resources[options][unavailable_products]=last';
      fetch(url, { signal: controller.signal })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
        .then(function (d) {
          if (input.value.trim() !== q) return;          // người dùng đã gõ tiếp
          render((d.resources.results.products) || [], q);
        })
        .catch(function (e) {
          if (e && e.name === 'AbortError') return;
          close();                                        // lỗi mạng thì im lặng
        });
    }

    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < MIN_CHARS) { close(); return; }
      timer = setTimeout(function () { search(q); }, DEBOUNCE);
    });

    input.addEventListener('focus', function () {
      if (panel.innerHTML && input.value.trim().length >= MIN_CHARS) open();
    });

    input.addEventListener('keydown', function (e) {
      if (panel.hidden) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); highlight(active + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); highlight(active - 1); }
      else if (e.key === 'Escape') { close(); }
      else if (e.key === 'Enter') {
        var list = items();
        if (active > -1 && list[active]) { e.preventDefault(); list[active].click(); }
      }
    });

    document.addEventListener('click', function (e) {
      if (!form.contains(e.target)) close();
    });
  }

  function boot() {
    var bars = document.querySelectorAll('.header__search-bar');
    Array.prototype.forEach.call(bars, function (bar) {
      /* chỉ gắn cho ô tìm kiếm hiện trên desktop; ô trong drawer mobile để nguyên */
      if (bar.closest('#search-drawer')) return;
      init(bar);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
